import { Injectable, InjectionToken, Type } from '@angular/core';

import { FormConfig, FormField } from '@services';
import { IObjectStringKeyMap } from '@shared/models';
import { FilterData } from '@shared/modules/menu-filter/services/filter-menu.service';
import { IFolder } from '../model/folders.interfaces';
import { IPopoverConfig } from '@modules/shared/components/popoverTemplate/popover-template.component';

@Injectable()
export abstract class FolderFactoryService {
  public filterData: FilterData = {};
  public abstract getFields(folderData?: IObjectStringKeyMap<any>): FormField[];
  public prepareDataBeforeRender?(folderData?: IObjectStringKeyMap<any>): void;
  public integrateParentAttributes?(folderData: IObjectStringKeyMap<any>, parentFolderData: IObjectStringKeyMap<any>): void;
  public onFinishRenderAddFolderForm?(formConfig: FormConfig): void;
  public getCopyFolderLink?(folderID: number): string;
  public normalizeFormData?(formData: IFolder): void;
  public checkAndUpdateSaveDialog?(folderData: IFolder, folderID: number, updatePopoverConfig: IPopoverConfig): void;
  /**
   * Optional method to pre-load any required data before the folder modal opens.
   * Implementations can override this to load data asynchronously.
   */
  public preloadData?(): Promise<void>;
}

export const FOLDER_FACTORY_SERVICE_TOKEN = new InjectionToken<Type<FolderFactoryService>>('FOLDER_FACTORY_SERVICE');
